module.exports = __webpack_public_path__ + "img/Sound3.98fb08fc.png";